const config = {
    apiUrl: process.env.REACT_APP_API_URL ?? 'http://timesheetapi.docker',
    appUrl: process.env.REACT_APP_APP_URL ?? 'http://timesheetapp.docker',
};

export default config;